import { i18nMark } from 'lingui-react';

export const CUSTOM_UI_STATES = {
  WORKING_ON_CASE: 'Working On Case',
};

export const UI_STATES = {
  ACW: 'ACW',
  AGENT_HOLD: 'AGENT_HOLD',
  AUX: 'AUX',
  AVAILABLE: 'AVAILABLE',
  CONNECTED: 'CONNECTED',
  CONNECTING: 'CONNECTING',
  DISCONNECTED: 'DISCONNECTED',
  ERROR: 'ERROR',
  INBOUND: 'INBOUND',
  INCOMING: 'INCOMING',
  INITIALIZING: 'INITIALIZING',
  MISSED: 'MISSED',
  MONITORING: 'MONITORING',
  OFFLINE: 'OFFLINE',
  ON_HOLD: 'ON_HOLD',
  OUTBOUND: 'OUTBOUND',
};

export const STATE_NAMES = {
  ACW: i18nMark('After Call Work'),
  AGENT_HOLD: i18nMark('Agent On Hold'),
  CONNECTED: i18nMark('Connected'),
  CONNECTING: i18nMark('Connecting'),
  DISCONNECTED: i18nMark('Disconnected'),
  ERROR: i18nMark('Error'),
  INBOUND: i18nMark('Inbound'),
  INCOMING: i18nMark('Incoming'),
  INCOMING_CALLBACK: i18nMark('Incoming Callback'),
  INITIALIZATION_FAILURE: i18nMark('Initialization Failure'),
  INITIALIZING: i18nMark('Initializing'),
  JOINED: i18nMark('Joined'),
  MISSED_CALL: i18nMark('Missed Call'),
  MONITORING: i18nMark('Monitoring'),
  MUTED: i18nMark('Muted'),
  ON_HOLD: i18nMark('On Hold'),
  OUTBOUND: i18nMark('Outbound'),
};

export const CONVERSATION_STATE_NAMES = [
  STATE_NAMES.CONNECTED,
  STATE_NAMES.ON_HOLD,
];

export const ACTIVE_CONNECTION_STATE_NAMES = [
  ...CONVERSATION_STATE_NAMES,
  STATE_NAMES.INBOUND,
  STATE_NAMES.INCOMING,
  STATE_NAMES.JOINED,
  STATE_NAMES.MONITORING,
];

/**
 * Mapping of various buttons we might present to users, and which
 * UI states are valid for each button to be enabled.
 */
export const UI_STATE_BUTTONS = {
  END_CALL: [
    UI_STATES.AGENT_HOLD,
    UI_STATES.CONNECTED,
    UI_STATES.CONNECTING,
    UI_STATES.MONITORING,
    UI_STATES.ON_HOLD,
    UI_STATES.OUTBOUND,
  ],
  ACCEPT_CALL: [UI_STATES.INCOMING, UI_STATES.INBOUND],
  REJECT_CALL: [UI_STATES.INCOMING, UI_STATES.INBOUND],
  GO_AVAILABLE: [
    UI_STATES.ACW,
    UI_STATES.AUX,
    UI_STATES.ERROR,
    UI_STATES.MISSED,
    UI_STATES.OFFLINE,
  ],
  GO_OFFLINE: [
    UI_STATES.ACW,
    UI_STATES.AUX,
    UI_STATES.AVAILABLE,
    UI_STATES.ERROR,
    UI_STATES.MISSED,
  ],
  CALL_OUTBOUND: [
    UI_STATES.ACW,
    UI_STATES.AUX,
    UI_STATES.AVAILABLE,
    UI_STATES.ERROR,
    UI_STATES.MISSED,
  ],
  TRANSFER_TO_QUICK_CONNECT: [UI_STATES.CONNECTED],
};

export const CONVERSATION_STATES = [UI_STATES.CONNECTED, UI_STATES.ON_HOLD];

export const DISABLED_STATE_NAMES = [
  STATE_NAMES.DISCONNECTED,
  STATE_NAMES.ERROR,
  STATE_NAMES.INITIALIZATION_FAILURE,
  STATE_NAMES.INITIALIZING,
];

const connectBaseUrl = process.env.REACT_APP_AMAZON_CONNECT_BASE_URL;

export const CCP_URLS = {
  CCP: `${connectBaseUrl}/ccp-v2`,
  LOGIN: process.env.REACT_APP_AMAZON_CONNECT_LOGIN_URL,
  LOGOUT: `${connectBaseUrl}/logout`,
  GET_RECORDING: `${connectBaseUrl}/get-recording`,
};

/**
 * Build a map of agent error states to display text.
 * @param connect The current Amazon Connect instance
 * @return {object}
 */
export function makeErrorStates(connect) {
  return {
    [connect.AgentErrorStates.AGENT_HUNG_UP]: i18nMark('Agent hung up'),
    [connect.AgentErrorStates.BAD_ADDRESS_CUSTOMER]: i18nMark('Bad address'),
    [connect.AgentErrorStates.BAD_ADDRESS_AGENT]: i18nMark('Bad address'),
    [connect.AgentErrorStates.FAILED_CONNECT_AGENT]: i18nMark(
      'Failed connection',
    ),
    [connect.AgentErrorStates.FAILED_CONNECT_CUSTOMER]: i18nMark(
      'Call no longer available',
    ),
    [connect.AgentErrorStates.LINE_ENGAGED_AGENT]: i18nMark('Line engaged'),
    [connect.AgentErrorStates.LINE_ENGAGED_CUSTOMER]: i18nMark('Line engaged'),
    [connect.AgentErrorStates.MISSED_CALL_CUSTOMER]: i18nMark('Missed call'),
    [connect.AgentErrorStates.MISSED_CALL_AGENT]: i18nMark('Missed call'),
    [connect.AgentErrorStates.MISSED_QUEUE_CALLBACK]: i18nMark(
      'Callback missed',
    ),
    [connect.AgentErrorStates.REALTIME_COMMUNICATION_ERROR]: i18nMark(
      'Real-time communication error',
    ),
    default: STATE_NAMES.ERROR,
  };
}

/**
 * This is the name of a "secret" query-string parameter that
 * QA can add to the ONCall URL to enable outbound-call phone
 * number overriding. The value of the parameter should be a
 * ten-digit phone number, digits only.
 *
 * If the query string is set on the application's URL at initial
 * application bootstrap, then any outbound call placed via
 * Amazon Connect will dial the given phone number instead of
 * the phone number requested by the application.
 *
 * @see AmazonConnectProvider#makeOutboundCall
 * @type {string}
 */
export const QUERY_PARAM_OUTGOING_CALL_OVERRIDE = 'outboundphone';



// WEBPACK FOOTER //
// ./src/features/amazonConnect/constants.js